module.exports = "/wp-content/themes/conversion/public/dist//svgs/our-approach-stages.svg";